import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * 生年月日チェッククラス
 */
export default class EFOcats_validate_birthday extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    const inputs = checkData.parents('.qa').find('select');

    const birthday_value = {
      birthdayYear: inputs.eq(0).val() || '',
      birthdayMonth: inputs.eq(1).val() || '',
      birthdayDay: inputs.eq(2).val() || '',
    };

    if (checkData.parents('.qa').find('.required').length > 0) {
      if (!checkData.val()) {
        result = new EFOcats_error_info('error', '必須項目です', '', '必須項目です');
      }
    } else if (birthday_value.birthdayYear || birthday_value.birthdayMonth || birthday_value.birthdayDay) {
      if (!checkData.val()) {
        result = new EFOcats_error_info('error', '未入力です', '', '未入力です');
      }
    }

    if (result.status === 'success' && inputs.eq(2).attr('name') === checkData.attr('name')) {
      if (!this.validDate(birthday_value)) {
        result = new EFOcats_error_info('error', '存在する日付を入力してください。', '', '存在する日付を入力してください。');
      }
    }

    return result;
  }

  /**
   * 日付チェック
   */
  validDate(birthday_value) {
    const dt = new Date(birthday_value.birthdayYear, birthday_value.birthdayMonth - 1, birthday_value.birthdayDay);
    return (
      dt.getFullYear() === Number(birthday_value.birthdayYear) && dt.getMonth() === Number(birthday_value.birthdayMonth) - 1 && dt.getDate() === Number(birthday_value.birthdayDay)
    );
  }
}
